module.exports = __webpack_public_path__ + "img/story044@2x.acd16bb4.png";